// Import CSS
import './index.css'

// Import JS
import Alpine from 'alpinejs'
 
// Globals
window.Alpine = Alpine;
 
// Start Alpine.js
Alpine.start();